import axios from "axios";
import { PageType } from "types/PageI";

const API_URL = process.env.REACT_APP_API_URL;

export const verifyHashService = async (verify_hash: string, verify_type: string | null) => {
    try {
        let response = await axios.post(
            API_URL + '/verify_email', 
            {
                hash: verify_hash,
                path: verify_type
            }
        )


        if ('error' in response.data) {
            return response.data.error
        }  



        if (!('client_id' in response.data)) {
            return "verify_hesh_no_client_error"
        }
      
        
        if (response.data.path === 'online') {
            return {
                page: PageType.create_password,
                user: response.data.client_id
            }
        }

        return {
            page: PageType.log_in_form,
            user: response.data.client_id
        }
        


    } catch (error) {
        return "verify_new_hash_error"
    }

}
